import { CACHE } from '../../globals';
import QueueItem from './QueueItem';

/**
 * @class
 * @inheritDoc
 * @extends module:media.module:loaders.QueueItem
 * @memberof module:media.module:loaders
 * @classdesc Загрузчик изображения
 */
class ImageLoader extends QueueItem {

    prepareData(src){
        let item = CACHE.get(src) || new Image();
        if (item.src !== src) {
            item.crossOrigin = 'undefined';
            item.src = src;
            CACHE.put(src, item);
        }
        return item;
    }

    prepareKey(src){
        return src;
    }

    load(cache = true){
        //super.load(cache);
        //let texture = PIXI.Texture.fromImage(this.data.src);
        if (!this.complete) {
            let self = this, to = null;

            let fn = function() {
                if (self.data.complete) {
                    self.data.onerror = null;
                    self._status = 'success';
                    //texture = null;
                    self.completeLoad(cache);
                }
                else {
                    to = setTimeout(fn, 100); // XXX: onload, onerror not fired on all browsers :(
                }
            };
            // try to handle errors
            this.data.onerror = function(){
                to = clearTimeout(to);
                self.data.onerror = null;
                self._status = 'error';
                self.completeLoad(cache);
            };
            fn();
        }
    }
}

export default ImageLoader;
